import React from "react";

const ProgressBar = ({
  progress,
  total,
  completed,
  severity,
  isSomeCanceled,
  isBlinking,
}) => {
  // Determine color class based on severity
  const getColorClass = () => {
    if (severity === "Stop") {
      return "bg-danger";
    } else if (severity === "Critical") {
      return "bg-warning";
    } else {
      return "bg-success"; // Report or default
    }
  };

  // Determine blink class based on severity
  const getBlinkClass = () => {
    if (!isBlinking) {
      return "";
    }
    if (severity === "Stop") {
      return "blink_red";
    } else if (severity === "Critical") {
      return "blink_yellow";
    } else {
      return "blink_me"; // Report or default (green)
    }
  };

  const blinkClass = getBlinkClass();

  return (
    <div
      className={`progress position-relative ${blinkClass}`}
      dir="rtl"
      style={{ height: "30px" }}
    >
      <div
        className={`progress-bar ${getColorClass()} ${
          progress === 100 || isSomeCanceled
            ? ""
            : "progress-bar-striped progress-bar-animated"
        }`}
        role="progressbar"
        aria-valuenow={progress}
        aria-valuemin="0"
        aria-valuemax="100"
        style={{ width: `${progress}%` }}
      ></div>
      <div
        className={`position-absolute top-50 start-50 ${
          progress >= 52 ? "text-white" : ""
        }`}
      >{`${total} / ${completed}`}</div>
    </div>
  );
};

export default ProgressBar;
